import { IFaceMatch } from '../@types/FaceMatch';
import { IPerson } from '../@types/Person';


export const IsFaceMatch = (value: IFaceMatch): value is IFaceMatch => {
  if(value === undefined)
        return false;
      
        if (value.name !== undefined && value.thumbnailUrl !== undefined)
          return true
        else
          return false;
      }
export const IsPerson = (value: IPerson): value is IPerson => {
  if(value === undefined)
        return false;
      
        if (value.name !== undefined && value.siteCode !== undefined && value.personUrl !== undefined)
          return true
        else
          return false;
      }
